import axios from 'axios';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import constant from '../utils/Constant';
import config from '../config/config';

const {
    LOGOUT_END_POINT,
    STATUS_401
} = constant;

function Logout() {
    const navigate = useNavigate();

    useEffect(() => {
        localStorage.removeItem('vendor_super_token');
        localStorage.removeItem('vendor_super_data');
        navigate('/')
    }, [navigate]);

    // const navigate = useNavigate();
    // const token = localStorage.getItem('vendor_super_token');

    // useEffect(() => {
    //     if (!token) {
    //         navigate('/')
    //     }
    // }, [token])

    // //* execute logout api 
    // const executeLogoutApi = async () => {
    //     try {
    //         const res = await axios.post(`${config.appBaseUrl + LOGOUT_END_POINT}`, {
    //             headers: {
    //                 Authorization: `Bearer ${token}`
    //             },
    //         });
    //         const result = res.data;
    //         if (result.status) {
    //             toast.success(result.message);
    //         } else {
    //             console.log('try else');
    //             if (!result.status && result.STATUS_401) {
    //                 localStorage.removeItem('vendor_super_token');
    //                 navigate('/')
    //             }
    //             toast.error(result.message);
    //         }
    //     } catch (error) {
    //         toast.error(error.message);
    //     }
    // };

    // useEffect(() => {
    //     executeLogoutApi();
    // }, [executeLogoutApi, token, navigate]);

    return null;
}

export default Logout;